import PropTypes from "prop-types";
import React from "react";
import {
  faCheckCircle,
  faTimesCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { RadioGroup } from "@headlessui/react";
import { useSession } from "@hooks";

type StepFastcheckoutProps = {
  selected: boolean;
  setSelected: (value: boolean) => void;
  singleConfirmFastCheckout: boolean;
};

const languagesVarsCodes = [
  "LANG_neobooking_your_fast_checkout", //Votre fast check-out
  "LANG_neobooking_fast_checkout_select_confirm", //Je souhaite l'option Fast check-out, et atteste avoir pris connaissance des conditions générales liées au fast check-out.
  "LANG_neobooking_fast_checkout_select_decline", //Je ne souhaite pas l'option Fast check-out.
  "LANG_neobooking_fast_checkout_validity_error", //Veuillez valider l'option Fast check-out, et attester avoir pris connaissance des conditions générales liées au fast check-out.
];

const StepFastcheckout: React.FC<StepFastcheckoutProps> = ({
  selected,
  setSelected,
  singleConfirmFastCheckout,
}) => {
  /* Hooks */
  const { getLanguageVarValue } = useSession();

  return (
    <div className="tw-flex tw-flex-col tw-gap-y-4">
      <div className="tw-titre-principal-dosis">
        {getLanguageVarValue("LANG_neobooking_your_fast_checkout")}
      </div>
      {singleConfirmFastCheckout ? (
        <div>
          <div className="tw-flex tw-gap-2 tw-items-center">
            <input
              id="primaryOccupantDetails_confirm"
              name="primaryOccupantDetails_confirm"
              type="checkbox"
              required
              checked={selected}
              onInvalid={(e) =>
                e.currentTarget.setCustomValidity(
                  getLanguageVarValue(
                    "LANG_neobooking_fast_checkout_validity_error"
                  )
                )
              }
              onChange={() => setSelected(!selected)}
              className={`tw-accent-primary-500 hover:tw-accent-primary-400 tw-h-4 tw-w-4`}
            />
            <label
              className="tw-leading-5"
              htmlFor="primaryOccupantDetails_confirm"
            >
              {getLanguageVarValue(
                "LANG_neobooking_fast_checkout_select_confirm"
              )}
            </label>
          </div>
        </div>
      ) : (
        <div>
          <RadioGroup value={selected} onChange={setSelected}>
            <RadioGroup.Label className="tw-sr-only">
              {getLanguageVarValue("LANG_neobooking_your_fast_checkout")}
            </RadioGroup.Label>
            <div className="tw-flex tw-flex-col tw-gap-2">
              <RadioGroup.Option
                as={"div"}
                value={true}
                className={({ active, checked }) =>
                  `${
                    active
                      ? "tw-ring-2 tw-ring-offset-2 tw-ring-offset-primary-500 tw-ring-white"
                      : ""
                  }
              ${
                checked
                  ? "tw-bg-primary-200 tw-text-primary-900 tw-ring-2 tw-ring-offset-2 tw-ring-offset-primary-500 tw-ring-white"
                  : "tw-bg-white"
              }
              tw-relative tw-rounded-lg tw-border tw-shadow tw-px-5 tw-py-4 tw-cursor-pointer tw-flex focus:tw-outline-none`
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                      <div className="tw-flex tw-items-center">
                        <div className="tw-text-sm tw-flex">
                          <RadioGroup.Description as="span">
                            <div style={{ width: "2rem" }}>
                              <FontAwesomeIcon icon={faCheckCircle} />
                            </div>
                          </RadioGroup.Description>
                          <RadioGroup.Label
                            as="p"
                            className={`tw-font-medium  ${
                              checked ? "tw-text-primary-900" : ""
                            }`}
                          >
                            {getLanguageVarValue(
                              "LANG_neobooking_fast_checkout_select_confirm"
                            )}
                          </RadioGroup.Label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
              <RadioGroup.Option
                as={"div"}
                value={false}
                className={({ active, checked }) =>
                  `${
                    active
                      ? "tw-ring-2 tw-ring-offset-2 tw-ring-offset-primary-500 tw-ring-white"
                      : ""
                  }
              ${
                checked
                  ? "tw-bg-primary-200 tw-text-primary-900 tw-ring-2 tw-ring-offset-2 tw-ring-offset-primary-500 tw-ring-white"
                  : "tw-bg-white"
              }
              tw-relative tw-rounded-lg tw-border tw-shadow tw-px-5 tw-py-4 tw-cursor-pointer tw-flex focus:tw-outline-none`
                }
              >
                {({ active, checked }) => (
                  <>
                    <div className="tw-flex tw-items-center tw-justify-between tw-w-full">
                      <div className="tw-flex tw-items-center">
                        <div className="tw-text-sm tw-flex">
                          <RadioGroup.Description as="span">
                            <div style={{ width: "2rem" }}>
                              <FontAwesomeIcon icon={faTimesCircle} />
                            </div>
                          </RadioGroup.Description>
                          <RadioGroup.Label
                            as="p"
                            className={`tw-font-medium  ${
                              checked ? "tw-text-primary-900" : ""
                            }`}
                          >
                            {getLanguageVarValue(
                              "LANG_neobooking_fast_checkout_select_decline"
                            )}
                          </RadioGroup.Label>
                        </div>
                      </div>
                    </div>
                  </>
                )}
              </RadioGroup.Option>
            </div>
          </RadioGroup>
        </div>
      )}
    </div>
  );
};

StepFastcheckout.propTypes = {
  //
};

export default StepFastcheckout;
